import { PaymentAPI, PaymentResponse } from '../../typings/Payment'
import {
  ConfirmOrderConfirmOrderDocument,
  ConfirmOrderConfirmOrderMutation,
  ConfirmOrderConfirmOrderMutationVariables,
} from '../../graphql'

const confirmOrder = async (paymentAPI: PaymentAPI, orderId: string): Promise<PaymentResponse> => {
  const { data, errors } = (await paymentAPI.apolloClient.mutate<
    ConfirmOrderConfirmOrderMutation,
    ConfirmOrderConfirmOrderMutationVariables
  >({
    mutation: ConfirmOrderConfirmOrderDocument,
    variables: { orderId },
  })) as { data?: ConfirmOrderConfirmOrderMutation; errors?: Array<Error> }

  if (data && data.confirmOrder.__typename === 'Order') {
    return { wasSuccessful: true }
  }

  if (data && data.confirmOrder.__typename === 'ExpectedErrors') {
    return { wasSuccessful: false, error: data.confirmOrder.errors[0].message }
  }

  if (errors) {
    return { wasSuccessful: false, error: errors[0].message }
  }

  return { wasSuccessful: false }
}

export default confirmOrder
